import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import charts from './modules/charts';
import home from './modules/home';
import account from './modules/account';
import navigation from './modules/navigation';
import localStore from './modules/localStore';
import filters from './modules/filters';
import maps from './modules/maps';
import groups from './modules/groups';
import screens from './modules/screens';
import groupDetails from './modules/groupDetails';
import screenDetails from './modules/screenDetails';
import reconciliation from './modules/reconciliation';
import reconciliationDetails from './modules/reconciliationDetails';
import reports from './modules/reports';
import digitalKeys from './modules/digitalKeys';
import digitalKeyDetails from './modules/digitalKeyDetails';
import reportDetails from './modules/reportDetails';
import areas from './modules/areas';
import loading from './modules/loading';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    charts,
    home,
    account,
    localStore,
    maps,
    navigation,
    filters,
    groups,
    screens,
    groupDetails,
    screenDetails,
    reconciliation,
    reconciliationDetails,
    reports,
    digitalKeys,
    digitalKeyDetails,
    reportDetails,
    areas,
    loading,
  },
});

export default store;
